module.exports = __webpack_public_path__ + "img/send-otp-successfully.8943d762.png";